import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { useState } from "react";
import {
  addToast,
  Button,
  Checkbox,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/react";
import { api } from "@/lib/api-client";
import { sentryLog } from "@/utils/sentry-utils";

export const ScrapeAcceptanceModal = () => {
  const [isAccepted, setIsAccepted] = useState(false);

  const { mutateAsync: acceptScrape, isPending } = api.client.useAcceptScrape();

  return (
    <Modal isOpen={true} hideCloseButton isDismissable={false}>
      <ModalContent>
        <ModalHeader>
          <Trans>Pregled uvoženih podatkov</Trans>
        </ModalHeader>

        <ModalBody>
          <p className="text-sm">
            <Trans>
              Vaši podatki so bili uspešno uvoženi. Prosimo vas, da pred uporabo
              aplikacije preverite, da so vsi podatki (storitve, stranke,
              termini, davčne stopnje itd.) pravilno preneseni.
            </Trans>
          </p>

          <p className="text-sm font-semibold">
            <Trans>
              S klikom na gumb potrdi potrjujete, da boste pregledali uvožene
              podatke in nas obvestili o morebitnih napakah. Po potrditvi se
              šteje, da so podatki pregledani in potrjeni z vaše strani, skladno
              s pogoji poslovanja.
            </Trans>
          </p>

          <Checkbox
            isSelected={isAccepted}
            onValueChange={setIsAccepted}
            size="sm"
            className="mt-2"
          >
            <Trans>Potrjujem, da bom pregledal/a uvožene podatke</Trans>
          </Checkbox>
        </ModalBody>

        <ModalFooter>
          <Button
            color="primary"
            isDisabled={!isAccepted}
            isLoading={isPending}
            onPress={async () => {
              try {
                await acceptScrape();
                window.location.href = "/";
              } catch (error) {
                addToast({
                  title: t`Napaka pri sprejemanju uvoza`,
                  description: t`Poskusite znova kasneje`,
                  color: "danger",
                });
                sentryLog.error("Error accepting scrape", {
                  error,
                });
              }
            }}
          >
            {t`Potrdi`}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
